import { SpatialFilter } from "@aipb/gulliver/castor/model";
import { CastorMapper } from './mapper';

export class SpatialFilterMapper implements CastorMapper<SpatialFilter> {
  map(o: SpatialFilter): { [p: string]: any } {
    if (!o) return {};

    return {
      ...o
    };
  }
}
